import React from "react"
import PropTypes from 'prop-types'
import { Route, Redirect } from "react-router-dom"
import validateToken from '../helpers/JWT/validateExpirionJWT';
import routePermissionAccess from '../middleware/routePermissionAccess';


const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      // Aqui chamar função para verificar tempo de expiração do token
      validateToken();

      // Passa as permissões de acesso nas rotas
      routePermissionAccess(props.match.path);
      
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default AppRoute
